<template>
  <v-layout column>
    <vbt-content-box
      :no-content="!barcodes.length"
      title="Barcodes"
      v-bind="$attrs"
    >
      <template #toolbar>
        <v-btn
          small
          color="success"
          @click="openBarcodeEditorDialog"
        >
          Create barcode
        </v-btn>
      </template>
      <vbt-table
        :headers="headers"
        :items="barcodes"
        :page-size="5"
        show-paginator
        show-remove-action
        show-details-action
        @click:remove="removeBarcode"
        @click:details="openBarcodeViewerDialog"
      />
    </vbt-content-box>

    <ums-user-barcode-viewer
      v-model="barcodeViewerDialog"
      :barcode="barcode"
    />

    <ums-user-barcode-editor
      v-model="barcodeEditorDialog"
      v-on="$listeners"
    />
  </v-layout>
</template>

<script>
import { useComponentWithDialog, useEditorWithDialog } from '@mixins/factories';

import { wrapToLoadingFn } from '@helpers';

import UmsUserBarcodeViewer from './UmsUserBarcodeViewer.vue';
import UmsUserBarcodeEditor from './UmsUserBarcodeEditor.vue';

import UsersApiService from '../_services/users.api.service';

const headers = Object.freeze([
  { text: 'Barcode', value: 'barcode' },
  { text: 'Description', value: 'description' },
]);

export default {
  name: 'UmsUserBarcodesList',
  props: {
    barcodes: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    UmsUserBarcodeViewer,
    UmsUserBarcodeEditor,
  },
  mixins: [
    useComponentWithDialog({
      dialogFlagName: 'barcodeViewerDialog',
      openTriggerName: 'openBarcodeViewerDialog',
    }),
    useEditorWithDialog({
      editorDialogFlagName: 'barcodeEditorDialog',
      openTriggerName: 'openBarcodeEditorDialog',
      editorModeFlagName: 'isCreateBarcode',
      editableItemName: 'editableBarcode',
    }),
  ],
  data: () => ({ headers, barcode: '' }),
  methods: {
    wrapToLoadingFn,
    removeBarcode({ barcode }) {
      this.$VBlackerTheme.alert.warning({
        text: `Remove barcode ${barcode}?`,
      }, () => this.wrapToLoadingFn({
        req: UsersApiService.removeUserBarcode.bind({}, {
          barcode,
          id: this.$route.params.id,
        }),
        fullscreenLoadingSpinner: true,
        onSuccess: () => {
          this.$VBlackerTheme.notification.success('User barcode successfully removed');
          this.$emit('change:success');
        },
      }));
    },
    openBarcodeViewerDialog({ barcode }) {
      this.barcode = barcode;
      this.barcodeViewerDialog = true;
    },
  },
};
</script>
